import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { t } = useLang();
  const settings = useSettings();
  const c = settings.company || {};
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#1E3A2F] text-white/90 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <img src="/logo-footer.png" alt="Belov Multiservice" className="h-14 w-auto" data-testid="footer-logo" />
            <p className="mt-3 text-sm text-white/70 leading-relaxed max-w-xs">{t.footer.tagline}</p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-white/50 font-semibold mb-4">{t.footer.services}</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/pax-montering" className="hover:text-white" data-testid="footer-pax">{t.nav.pax}</Link></li>
              <li><Link to="/oevrige-moebler" className="hover:text-white" data-testid="footer-other">{t.nav.other}</Link></li>
              <li><Link to="/ikea-koekken" className="hover:text-white" data-testid="footer-kitchen">{t.nav.kitchen}</Link></li>
              <li><Link to="/serviceomraade" className="hover:text-white" data-testid="footer-area">{t.nav.area}</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-white/50 font-semibold mb-4">{t.footer.legal}</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privatlivspolitik" className="hover:text-white" data-testid="footer-privacy">{t.footer.privacy}</Link></li>
              <li><Link to="/handelsbetingelser" className="hover:text-white" data-testid="footer-terms">{t.footer.terms}</Link></li>
              <li><Link to="/kontakt" className="hover:text-white" data-testid="footer-contact">{t.footer.contactPage}</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-white/50 font-semibold mb-4">{t.footer.contact}</div>
            <ul className="space-y-2 text-sm text-white/80">
              {c.phone && <li><a href={`sms:${c.phone.replace(/\s/g, "")}`} className="hover:text-white" data-testid="footer-sms">{c.phone}</a></li>}
              {c.phone && <li className="text-white/50 text-xs -mt-1.5">{t.contact.sms}</li>}
              {c.email && <li><a href={`mailto:${c.email}`} className="hover:text-white">{c.email}</a></li>}
              {c.city && <li>{c.city}</li>}
              {c.cvr && <li data-testid="footer-cvr">CVR: {c.cvr}</li>}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/15">
          <p className="text-xs text-white/55 leading-relaxed max-w-4xl" data-testid="independence-disclaimer">
            <strong className="text-white/75">{c.name || "Belov Multiservice"}</strong> {t.footer.disclaimer}
          </p>
          <p className="mt-4 text-xs text-white/40">© {year} {c.name || "Belov Multiservice"}. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
